import { GlassView } from 'expo-glass-effect';
import React from 'react';
import { Platform, StyleSheet, ViewStyle } from 'react-native';

interface GlassViewProps {
	children: React.ReactNode;
	style?: ViewStyle;
	glassEffectStyle?: 'clear' | 'regular';
	isInteractive?: boolean;
	tintColor?: string;
}

/**
 * GlassView component that provides native iOS glass effects
 * Falls back to regular view on non-iOS platforms
 */
export const GlassViewComponent: React.FC<GlassViewProps> = ({
	children,
	style,
	glassEffectStyle = 'regular',
	isInteractive = true,
	tintColor,
}) => {
	// Only use glass effect on iOS
	if (Platform.OS === 'ios') {
		return (
			<GlassView
				glassEffectStyle={glassEffectStyle}
				isInteractive={isInteractive}
				tintColor={tintColor}
				style={[styles.glassView, style]}
			>
				{children}
			</GlassView>
		);
	}

	// Fallback for non-iOS platforms
	return (
		<GlassView
			style={[
				styles.fallbackView,
				style,
			]}
		>
			{children}
		</GlassView>
	);
};

const styles = StyleSheet.create({
	glassView: {
		// Default glass view styles
	},
	fallbackView: {
		backgroundColor: 'rgba(255, 255, 255, 0.9)',
		borderRadius: 12,
		// Note: backdrop-filter is not supported in React Native StyleSheet
		// It would need to be applied via web-specific CSS
	},
});
